/* eslint react-hooks/exhaustive-deps: 0 */
import React, { useEffect } from "react";
import { useQuery, useClient } from "jsonapi-react";
import { useHistory } from "react-router-dom";
import DataTable from "react-data-table-component";
import axios from "axios";
import _ from "lodash";
import {
  checkModuleViewPermission,
  formatTextWithFallback,
  getCategoryType,
  getIdNumber,
  parseIdentificationType,
} from "../../helpers/helpers";

import { VW_ROUTES, apiRoutes, reportDatewoTimeFormat } from "../../constants";
import ReportFilter from "../../components/common/ReportFilter/BCAReportFilter";
import ProfileCard from "../../components/ProfileCard/ProfileCard";
import { AppContext } from "../../context/AppContext";
import useStorage from "../../helpers/useStorage";
import {
  defaultFromDateFilterValue,
  defaultToDateFilterValue,
} from "../../helpers/utils";
import BCAReportExpansionComponent from "./components/BCAReportExpansionComponent";
import { useToasts } from "react-toast-notifications";

const GeneralReport = () => {
  const { addToast } = useToasts();

  const { setToStorage, getFromStorage } = useStorage();
  const { userRoleDetails } = React.useContext(AppContext);
  const [filterChanged, setFilterChanged] = React.useState(false);
  const [currentPageNumber, setCurrentPageNumber] = React.useState(
    getFromStorage("bca_report_page_no") ?? 1
  );
  const [rowsPerPage, setRowsPerPage] = React.useState(
    getFromStorage("bca_report_rows_per_page") ?? 10
  );
  const { manageLoader } = React.useContext(AppContext);
  const [showSuccessModal, setShowSuccessModal] = React.useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = React.useState("");
  const [showMobileDataFilter, setShowMobileDataFilter] = React.useState(false);

  const [beforeDate, setBeforeDate] = React.useState(
    getFromStorage("bca_report_filter_before_date") ??
      defaultFromDateFilterValue(reportDatewoTimeFormat)
  );
  const [afterDate, setAfterDate] = React.useState(
    getFromStorage("bca_report_filter_after_date") ??
      defaultToDateFilterValue(reportDatewoTimeFormat)
  );
  const [disableExport, setdisableExport] = React.useState(true);

  const history = useHistory();
  const token = localStorage.getItem("access_token");
  const client = useClient();
  client.config.headers = {
    Authorization: `JWT ${token}`,
  };

  let filter;

  filter = {
    ...(afterDate !== null &&
      afterDate !== undefined &&
      afterDate !== "" && { end_date: afterDate }),
    ...(beforeDate !== null &&
      beforeDate !== undefined &&
      beforeDate !== "" && { start_date: beforeDate }),
  };

  const applicants = useQuery(
    [
      "reports",
      "bca",
      {
        ...filter,
        page: {
          number: currentPageNumber,
          size: rowsPerPage,
        },
        include: "personPhoto,category,personLastVisit,trade",
      },
    ],
    { client }
  );

  useEffect(() => {
    if (applicants?.data?.length > 0) {
      setdisableExport(false);
    } else {
      setdisableExport(true);
    }
  }, [applicants?.data]);

  const handleUpdateKey = () => {
    if (!filterChanged) {
      applicants.refetch();
    }
    setFilterChanged(false);
  };

  const customStyles = {
    headCells: {
      style: {
        fontWeight: "bold",
        fontSize: "14px",
      },
    },
  };
  const getEvent = (mode) => {
    if (mode.mode === "view") {
      viewDetails(mode?.person);
    }
  };

  const viewDetails = (personData) => {
    history.push({
      pathname: VW_ROUTES.PERSON_PROFILE_VIEW,
      search: `?id=${personData?.id}`,
      state: {
        from: history.location?.pathname,
      },
    });
  };

  const columns = [
    {
      name: "Name",
      selector: (person) => person?.fullName,
      minWidth: 250,
      sortable: true,
      cell: (person) => (
        <ProfileCard
          data={person}
          mode="BCAReport"
          actions={userRoleDetails}
          cellMode={getCategoryType(person?.category?.slug)}
          fields={[
            {
              value: (
                <span className="text-capitalize">
                  {formatTextWithFallback(person?.category?.name)}
                </span>
              ),
              name: "Category",
            },
            {
              value: (
                <span className="text-uppercase">
                  {formatTextWithFallback(person?.idType)}
                </span>
              ),
              name: "ID Type",
            },
            {
              value: (
                <span className="text-uppercase">
                  {formatTextWithFallback(person?.idNumber)}
                </span>
              ),
              name: "ID Number",
            },
            {
              value: (
                <span className="text-capitalize">
                  {formatTextWithFallback(person?.trade?.name)}
                </span>
              ),
              name: "Trade",
            },
          ]}
          actionsToParent={(mode) => getEvent({ mode, person })}
        />
      ),
    },
    {
      name: "Category",
      selector: (person) => person?.category?.name,
      minWidth: 150,
      sortable: false,
      cell: (person) => (
        <span className="text-capitalize text-left">
          {formatTextWithFallback(person?.category?.name)}
        </span>
      ),
      hide: "md",
    },
    {
      name: "ID Type",
      sortable: false,
      hide: "md",
      minWidth: 100,
      selector: (person) => person?.idType,
      cell: (person) => (
        <span className="text-uppercase text-left">
          {formatTextWithFallback(person?.idType)}
        </span>
      ),
    },
    {
      name: "ID Number",
      selector: (person) => (
        <span className="text-uppercase text-left">
          {formatTextWithFallback(person?.idNumber)}
        </span>
      ),
      sortable: false,
      minWidth: 150,
      hide: "md",
    },
    {
      name: "Trade",
      selector: (person) => (
        <span className="text-capitalize text-left">
          {formatTextWithFallback(person?.trade?.name)}
        </span>
      ),
      sortable: false,
      minWidth: 250,
      hide: "md",
    },
    {
      name: "Actions",
      sortable: false,

      center: true,
      maxWidth: 100,
      minWidth: 100,
      cell: (person) =>
        checkModuleViewPermission(
          userRoleDetails,
          getCategoryType(person?.category?.slug),
          "profile",
          person
        ) ? (
          <span
            className="simple-icon-eye user-role-action-icons view"
            onClick={() => viewDetails(person)}
          ></span>
        ) : (
          <></>
        ),
      right: true,
      hide: "md",
    },
  ];

  const onChangePage = (page) => {
    setCurrentPageNumber(page);
    setToStorage({ bca_report_page_no: page }, true);
  };

  const onChangeRowsPerPage = (rows) => {
    setToStorage({ bca_report_rows_per_page: rows }, false);
    setRowsPerPage(rows);
  };

  const closeReportSuccessPopup = () => {
    setShowSuccessModal(false);
    setShowSuccessMessage("");
  };

  const onExport = () => {
    manageLoader(true);
    let filterString = "";
    if (applicants?.data?.length > 0) {
      if (beforeDate !== undefined && afterDate !== undefined) {
        filterString = `?start_date=${beforeDate}&end_date=${afterDate}`;
      }

      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
          Authorization: `JWT ${token}`,
        },
        url: `${apiRoutes.bcaExport}${filterString}`,
      };
      axios(options)
        .then((response) => {
          manageLoader(false);
          setShowSuccessModal(true);
          setShowSuccessMessage(response.data.data.message);
        })
        .then(() => {
          manageLoader(false);
        })
        .catch((error) => {
          manageLoader(false);
          addToast(
            error?.response?.data?.errors?.message ??
              "Failed to export! Please try again later.",
            { appearance: "error" }
          );
        });
    } else {
      manageLoader(false);
      setShowSuccessModal(true);
      setShowSuccessMessage("There is no data to export");
    }
  };
  const showFilter = (mode) => {
    setShowMobileDataFilter(mode);
  };
  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="page-header">
            <h1>Man-hour Report </h1>

            <div className="cmn-btn">
              {/* {checkModuleGeneralPermission(userRoleDetails, "profile-report", "export_report") &&
              (<button className="btn btn-primary">Export</button>)} */}
            </div>

            <div
              className="tableFilterButton"
              title="Advance Search"
              onClick={() => showFilter(true)}
            >
              <i className="iconsminds-filter-2"></i>
            </div>
          </div>
          <div className="ReportFilterHolder">
            <div
              className={
                showMobileDataFilter ? "table-filter active" : "table-filter"
              }
            >
              <div
                className="filter-hide"
                onClick={() => showFilter(false)}
              ></div>
              <div className="filter-form">
                <h4 className="advanced-filter-heading mb-3">
                  Advanced Search
                </h4>
                <div className="reportSearch">
                  <ReportFilter
                    handleUpdateKey={handleUpdateKey}
                    setCurrentPageNumber={setCurrentPageNumber}
                    setFilterChanged={setFilterChanged}
                    loading={applicants?.isFetching}
                    onExport={onExport}
                    onBeforeDateChange={setBeforeDate}
                    onAfterDateChange={setAfterDate}
                    buttonVisibility={disableExport}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 col-md-12 mb-4">
          <div className="card">
            {/* <JSONConverter /> */}
            <div
              className={
                applicants.isFetching
                  ? "card-body remove-header dataTableOuter reportTable table-loader"
                  : "card-body remove-header dataTableOuter reportTable"
              }
            >
              <DataTable
                subHeader={true}
                progressPending={applicants.isFetching}
                progressComponent={<p>&nbsp;</p>}
                columns={columns}
                data={applicants?.data}
                customStyles={customStyles}
                paginationServer={true}
                striped={true}
                onChangePage={onChangePage}
                onChangeRowsPerPage={onChangeRowsPerPage}
                pagination={true}
                paginationPerPage={rowsPerPage}
                paginationTotalRows={applicants?.meta?.pagination?.count}
                paginationDefaultPage={currentPageNumber}
                expandableRows
                expandableRowsComponent={BCAReportExpansionComponent}
              />
            </div>
          </div>
        </div>
      </div>

      <div className={`reportStatusPopup ${showSuccessModal ? "show" : ""}`}>
        <div className="popUp">
          <div className="content">{showSuccessMessage}</div>
          <div className="action">
            <button
              className="btn btn-secondary"
              onClick={closeReportSuccessPopup}
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default GeneralReport;
